import "../../../mixins/conditional_visibility.js";
import "../../../mixins/recoverable_error.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.ConfirmationStep ??= {};

AppointmentBooking.Wizard.Views.ConfirmationStep.RecoverableErrorModal = class RecoverableErrorModal extends (
  AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty(
    AppointmentBooking.Wizard.Views.Mixins.RecoverableError(AppointmentBooking.Wizard.Views.Base),
  )
) {
  constructor() {
    super(...arguments);
  }

  // HELPER FUNCTIONS

  completeBooking() {
    this.model.set("errors", []);
    return this.triggerEvent(AppointmentBooking.Wizard.Events.Navigation["continueButtonClicked"]);
  }
};
AppointmentBooking.Wizard.Views.ConfirmationStep.RecoverableErrorModal.prototype.template =
  "step/confirmation/modals/recoverable_error";
AppointmentBooking.Wizard.Views.ConfirmationStep.RecoverableErrorModal.prototype.className =
  "appointment-booking-wizard-confirmation-step-recoverable-error-modal";
AppointmentBooking.Wizard.Views.ConfirmationStep.RecoverableErrorModal.prototype.events = {
  'click [data-appointment-booking-wizard-behaviour="complete"]': "completeBooking",
};
AppointmentBooking.Wizard.Views.ConfirmationStep.RecoverableErrorModal.prototype.recoverableErrorTypes = [
  "base_epic_invalid_patient_name_error",
  "primary_phone_invalid",
];
